var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 5.44771 4.44772 5 5 5H16V13H9L4 16V6Z",
    stroke: "#0F2342",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.75C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25V17.75ZM20 20H20.75C20.75 20.2702 20.6047 20.5195 20.3695 20.6526C20.1344 20.7858 19.8458 20.7821 19.6141 20.6431L20 20ZM15 17V16.25C15.1359 16.25 15.2693 16.2869 15.3859 16.3569L15 17ZM19.25 20V10H20.75V20H19.25ZM8 16.25H15V17.75H8V16.25ZM15.3859 16.3569L20.3859 19.3569L19.6141 20.6431L14.6141 17.6431L15.3859 16.3569ZM19 9.75H18V8.25H19V9.75ZM19.25 10C19.25 9.86193 19.1381 9.75 19 9.75V8.25C19.9665 8.25 20.75 9.0335 20.75 10H19.25Z",
    fill: "#0F2342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNotification);
export default __webpack_public_path__ + "static/media/info-notification.78e6b479179cf5125156d94b5d1c365f.svg";
export { ForwardRef as ReactComponent };